<template>
  <div class="payslips tile">
    <div class="tile__header mb--4" :style="'background: #3d7bf2'">
      <h3>Work Documents</h3>
      <img class="tile__header__image" :src="require('../assets/icons/wallet.svg')" />
    </div>
    <div class="container text--center">
      <p>Click on the document to view it</p>
      <div class="payslips__table">
      <ui-loading :loading="loading" />
        <table v-if="!loading && documents.length" class="mdl-data-table mdl-js-data-table m--auto w--100">
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in documents" :key="data.name" @click="openUrl(data.url)">
              <td>{{data.name}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import UiLoading from '../components/UILoading'

export default {
  name: 'red-rock-work-documents',
  components: { UiLoading },
  data: () => ({
    loading: false,
    documents: []
  }),
  computed: {
    clientId () {
      return this.$store.state.clientId
    }
  },
  methods: {
    openUrl (url) {          
      window.open(url)
    }
  },
  async mounted () {
    this.loading = true

    if (this.clientId === 'c07caf9b-cedd-405c-83d5-6dd911b5c1c1') {
      this.documents.push(      {
        name: 'Contract of Employment',
        url: 'https://ewage-public.s3.eu-west-2.amazonaws.com/red-rock/Contract_of_employment.pdf'
      },
      {
        name: 'Recruitment Worker Handbook',
        url: 'https://ewage-public.s3.eu-west-2.amazonaws.com/red-rock/Worker_handbook.pdf'
      })

      this.loading = false
    } else {
      this.$router.push('/')
    }
  },
}
</script>

<style lang="scss" scoped>
table {
  tbody {
    tr {
      cursor: pointer;
    }
  }
  th,td {
    text-align: left;
  }
}
</style>
